module.exports = __webpack_public_path__ + "static/media/1-todo-list.6469b938.png";